module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_6000.bf6aff28.png";